import { useEffect, useRef } from "react";

export const useScrollByDragging = (draging: boolean, target?: HTMLElement | null) => {
  const pivotCoords = useRef<{ x: number; y: number } | null>(null);

  while (
    target &&
    (!/^(auto|scroll)$/.test(window.getComputedStyle(target).overflowY) ||
    target.clientHeight >= target.scrollHeight)
  ) {
    target = target.parentElement;
  }

  useEffect(() => {
    if (!draging) return;

    const handleMouseMove = (event: globalThis.DragEvent) => {
      handleScrollByDraggingMiner(event, pivotCoords.current, target);
    };

    (target || window).addEventListener("dragover", handleMouseMove as any);

    return () => (target || window).removeEventListener("dragover", handleMouseMove as any);
  }, [draging]);
};

function handleScrollByDraggingMiner(
  event: globalThis.DragEvent,
  pivotCoords: { x: number; y: number } | null,
  target?: HTMLElement | null
) {
  const rect = target?.getBoundingClientRect();
  const cursorX = event.clientX - (rect?.left || 0);
  const cursorY = event.clientY - (rect?.top || 0);
  const viewportWidth =
    target ? target.clientWidth : window.innerWidth || document.documentElement.clientWidth;
  const viewportHeight =
    target ? target.clientHeight : window.innerHeight || document.documentElement.clientHeight;
  const edgeThreshold = 50;

  pivotCoords = { x: viewportWidth / 2, y: viewportHeight / 2 };

  if (cursorX < edgeThreshold || cursorX > viewportWidth - edgeThreshold) {
    if (pivotCoords) {
      const destination = mouseDestination(pivotCoords.x, cursorX);

      document
        .querySelector("#rack_container_wrapper")
        ?.scrollBy(destination, 0);
    }
  }

  if (cursorY < edgeThreshold || cursorY > viewportHeight - edgeThreshold) {
    if (pivotCoords) {
      const destination = mouseDestination(pivotCoords.y, cursorY);
      (target || window).scrollBy(0, destination);
    }
  }
}

const mouseDestination = (prev: number, current: number) => {
  if (prev > current) {
    return -5;
  } else {
    return 5;
  }
};
